<template>
  <div>
    <!--  Редактирование пользователя  -->
    <v-modal
        id="edit-user-modal"
        :modalTitle="modalTitle"
        hide-default-footer
        @close="user={}"
    >
      <template #modal-content>
        <app-edit-user-form
            :user="user"
            @updateUser="updateUser"
        />
      </template>

      <template #modal-footer>
        <div class="d-flex justify-content-between">
          <b-button
              variant="danger"
              @click="showCaution"
          >
            Удалить
          </b-button>

          <div>
            <b-button
                class="mr-3"
                variant="outline-secondary"
                @click="closeModal('edit-user-modal')"
            >
              Отменить
            </b-button>

            <b-button
                variant="success"
                :disabled="!isSaveAllow"
                @click="saveUser"
            >
              Сохранить
            </b-button>
          </div>
        </div>
      </template>

    </v-modal>

    <!--  Подтверждение удаления пользователя  -->
    <v-modal
        id="approve-delete-user"
        modalTitle="Удаление"
        hide-default-footer
    >
      <template #modal-content>
        Вы действительно хотите удалить пользователя <b>{{ user.username ? user.username : user.id }}</b>?
      </template>

      <template #modal-footer>
        <div class="d-flex justify-content-end mt-3">
          <b-button
              class="mr-3"
              variant="danger"
              @click="deleteUser"
          >
            Удалить
          </b-button>


          <b-button
              variant="outline-secondary"
              @click="closeModal('approve-delete-user')"
          >
            Отменить
          </b-button>

        </div>
      </template>
    </v-modal>
  </div>
</template>

<script>
import VModal from "@/common/VModal.vue";
import AppEditUserForm from "@/components/AppEditUserForm.vue";
import {ApiService} from "@/api";
import {eventBus} from "@/eventBus";

export default {
  name: 'AppEditUserModal',
  components: {AppEditUserForm, VModal},
  props: {
    clickedUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isSaveAllow: false,
      user: {},
    }
  },
  computed: {
    modalTitle() {
      return `Редактирование юзера ${this.user.username ? this.user.username : this.user.id}`
    },
  },
  watch: {
    clickedUser: {
      immediate: true,
      handler (newVal) {
       this.user = {...newVal}
      },
    }
  },
  methods: {
    open() {
      this.$bvModal.show('edit-user-modal')
    },
    closeModal(id) {
      this.$bvModal.hide(id)
    },
    showCaution() {
      this.$bvModal.show('approve-delete-user')
    },
    saveUser() {
      return ApiService.updateUser(this.user)
          .then(() => {
            eventBus.$emit('updateUser', this.user)
            this.closeModal('edit-user-modal')
          })
          .catch(err => console.error(err))
    },
    deleteUser() {
      return ApiService.deleteUser(this.user.id)
          .then(() => {
            this.closeModal('approve-delete-user')
            this.closeModal('edit-user-modal')
            eventBus.$emit("deleteUser", this.user.id);
          })
          .catch(err => console.error(err))
    },
    updateUser(user) {
      this.user = user;
      this.isSaveAllow = true

      const botKeyLength = user.botKey?.length || 0
      if(![0, 32].includes(botKeyLength)) {
        this.isSaveAllow = false
      }
    },
  },
}
</script>
